export function tournamentYears(season: string): string[] {
  return [...new Set(season.match(/\d{4}/g) ?? [])];
}
export function tournamentType(format: string): string {
  return /кубок/i.test(format) ? "Кубок" : "Чемпионат";
}
export function tournamentMatchesFilters(item: {ageCategory:string;season:string;format:string}, filters: {ageCategory:string;year:string;season:string;type:string}): boolean {
  return (filters.ageCategory === "all" || item.ageCategory === filters.ageCategory)
    && (filters.year === "all" || tournamentYears(item.season).includes(filters.year))
    && (filters.season === "all" || item.season === filters.season)
    && (filters.type === "all" || tournamentType(item.format) === filters.type);
}

export function tournamentSeasonKey(season: string) {
  const years = season.match(/\d{4}/g)?.map(Number) ?? [];
  if (!years.length) return 0;
  const start = years[0];
  const end = years.length > 1 ? years[1] : start;
  // Within one calendar cycle: winter after summer of the preceding year.
  const phase = /зима/i.test(season) ? 2 : 1;
  return end * 10000 + start * 10 + phase;
}
